/** Stable browser URL for a model's file (the route 302s to the bytes). Safe to persist. */
export function modelFileUrl(model: { id: number; model_url: string }, opts: { token?: string | null } = {}): string {
  const filename = model.model_url.split('/').pop() || 'model';
  const query = opts.token ? `?${new URLSearchParams({ token: opts.token })}` : '';
  return `/api/files/models/${model.id}/${encodeURIComponent(filename)}${query}`;
}

/** The share token on the current page's URL, for click handlers on private tones. */
export function pageShareToken(): string | null {
  return typeof window === 'undefined' ? null : new URLSearchParams(window.location.search).get('token');
}
